import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Attachment, AttachmentDtoInput, AttachmentToSave} from "../../../store/entities/shared/attachment.model";
import {GraphqlService} from "../../../services/graphql.service";
import {NotificationService} from "../../../services/notification.service";
import {UPLOAD_ATTACHMENT} from "../../../store/entities/shared/attachment.graphql";
import {BaseResponse} from "../../../common/interfaces/global-interfaces";
import {AttachmentService} from "../../../services/attachment.service";

@Component({
  selector: 'app-drag-drop-attachment',
  templateUrl: './drag-drop-attachment.component.html',
  styleUrl: './drag-drop-attachment.component.scss'
})
export class DragDropAttachmentComponent implements OnInit {

  @ViewChild("fileDropRef", {static: false}) fileDropRef: ElementRef;

  @Input() savedFiles: Attachment[] = [];

  files: any[] = [];

  file: File;

  @Input()
  acceptableFileTypes: string[] = ['.pdf'];

  @Input()
  isMultiple: boolean = true;

  @Input()
  filesToSave: AttachmentToSave[] = [];

  @Input()
  attachmentTitle = 'Drag and drop file here';

  @Output()
  getFiles = new EventEmitter<AttachmentToSave[]>();

  loading: boolean;

  isLoading: {[id: string]: boolean} = {};

  constructor(
    private apollo: GraphqlService,
    private notificationService: NotificationService,
    private attachmentService: AttachmentService,
  ) {
  }

  ngOnInit(): void {
    if (this.savedFiles?.length > 0) {
      this.files = this.savedFiles.map(sf => ({name: sf.fileName, size: null}));
      this.filesToSave = [...this.savedFiles.map(sf => ({fileName: sf.fileName, filePath: sf?.filePath}))];
      this.getFiles.emit(this.filesToSave);
    }
  }

  async openAttachment(attachment: any, index: number) {
    this.isLoading[index] = true;
    try {
      const response = await this.attachmentService.readAttachment(attachment?.filePath);
      await this.attachmentService.viewPdfInModal(response.base64String, attachment.fileName);
    } catch (e) {}
    this.isLoading[index] = false;
  }

  /**
   * on file drop handler
   */
  onFileDropped(event: any) {
    this.prepareFilesList(event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.filesToSave.splice(index, 1);
    if (this.filesToSave.length > 0) this.getFiles.emit(this.filesToSave);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      // validate for acceptable file types.
      if (!this.acceptableFileTypes.includes('.'+item?.name?.split('.')[1]?.toLowerCase())) {
        this.notificationService.errorMessage('File type not supported.');
      } else {
        this.onFileSelected(item);
      }
    }
    this.fileDropRef.nativeElement.value = "";
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2): any {
    if (!!bytes) {
      if (bytes === 0) {
        return "0 Bytes";
      }
      const k = 1024;
      const dm = decimals <= 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    } else {
      return 'already saved';
    }
  }

  onFileSelected(file: any) {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.toString().split(',')[1];
        this.file = file;
        this.saveAttachment({fileName: file.name, base64String}).then();
      };
    }
  }

  async saveAttachment(dto: AttachmentDtoInput) {
    this.loading = true;
    try {
      const response = await this.apollo.mutate({
        mutation: UPLOAD_ATTACHMENT,
        variables: {input: dto}
      });

      const result: BaseResponse<Attachment> = Object.values(Object.values(response)[0])[0];
      if (result.response.status) {
        this.files = [...this.files, this.file];
        this.filesToSave = [...this.filesToSave, {fileName: this.file.name, filePath: result?.data?.filePath}];
        this.getFiles.emit(this.filesToSave);
        this.notificationService.successMessage('Attachment successfully saved', null,null, false);
      } else {
        throw Error(result?.response?.message);
      }
    } catch (e) {
      this.notificationService.errorMessage(e.message);
    }
    this.loading = false;
  }

}
